import React from 'react';

import { Icon } from '@material-ui/core';
import { CSVLink } from 'react-csv';

import Button from '../../../components/Button';
import { ICSVData } from './Ledger';

interface ITransactionsHeader {
  openFiltersSection: boolean;
  setOpenFiltersSection: any;
  CSVData: ICSVData[];
  clubId: number;
}

export const TransactionsHeader = (props: ITransactionsHeader) => {
  const { clubId, openFiltersSection, setOpenFiltersSection, CSVData } = props;
  const CSVHeaders = [
    { label: 'id', key: 'id' },
    { label: 'Date', key: 'date' },
    { label: 'Event Name', key: 'eventName' },
    { label: 'Payer Name', key: 'payeer' },
    { label: 'Type', key: 'type' },
    { label: 'Amount', key: 'amount' },
    { label: 'Payment Method', key: 'paymentMethod' }
  ];
  return (
    <div className="buttons-section">
      <Button
        style={{ width: 'initial' }}
        id="subheader-sendButton"
        color="primary"
        type="button"
        onClick={() => {
          setOpenFiltersSection(!openFiltersSection);
        }}
      >
        <Icon classes={{ root: 'filter-icon' }}>
          {openFiltersSection ? 'arrow_upwards' : 'filter_list'}
        </Icon>
        {openFiltersSection ? 'HIDE FILTERS' : 'FILTER TRANSACTIONS'}
      </Button>
      <Button
        className="csv-button"
        style={{ width: 'initial' }}
        color="primary"
        type="button"
        variant="contained"
      >
        <CSVLink
          data={CSVData}
          headers={CSVHeaders}
          filename={`club${clubId}_transactionsReport.csv`}
          className="btn btn-primary"
          target="_blank"
        >
          EXPORT TRANSACTIONS TO .CSV
        </CSVLink>
      </Button>
    </div>
  );
};
